import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import { CF_GROUP_ROUTE, SYSTEM, SYSTEM_CONFIGURATION_ROUTE } from '../../constants';
import CollectionFunctionGroupCreate from './containers/CollectionFunctionGroupCreate';
import CollectionFunctionGroupEdit from './containers/CollectionFunctionGroupEdit';
import CollectionFunctionGroupList from './containers/CollectionFunctionGroupList';
import CollectionFunctionGroupView from './containers/CollectionFunctionGroupView';

interface Props {}

const CollectionFunctionGroup: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${CF_GROUP_ROUTE}`}>
        <CollectionFunctionGroupList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${CF_GROUP_ROUTE}/create`}>
        <CollectionFunctionGroupCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${CF_GROUP_ROUTE}/edit`}>
        <CollectionFunctionGroupEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${CF_GROUP_ROUTE}/view`}>
        <CollectionFunctionGroupView />
      </Route>
    </Fragment>
  );
};

export default CollectionFunctionGroup;
